import { Label } from "@/components/ui/label";

export default function FieldRow({ label, children }) {
  return (
    <div className="space-y-1">
      <Label className="text-[10px] font-semibold text-[#5C5F5A] uppercase tracking-wider">{label}</Label>
      {children}
    </div>
  );
}
